import styled, { css } from 'styled-components';

type TSlotProps = {
  isActive: boolean;
};

export const Container = styled.main`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    gap: clamp(${theme.layout.spacing(1)}, 2vw, ${theme.layout.spacing(3)});
  `}
`;

export const SlotContainer = styled.div<TSlotProps>`
  ${({ theme, isActive }) => css`
    width: clamp(42px, 14vw, 80px);
    height: clamp(56px, 16vw, 100px);

    border-radius: 0.5rem;
    border: 1px solid ${theme.palette.neutral[300]};

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: ${theme.typography.sizes.title1};
    font-weight: ${theme.typography.weight.regular};

    transition: 0.2s;

    ${isActive &&
    css`
      border-color: ${theme.palette.primary.main};
    `}
  `}
`;
